;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { useState, useEffect, useCallback } from "react"
import useEmblaCarousel from "embla-carousel-react"
import map from "lodash/map"
import { PrevButton, NextButton } from "../../../shared/YellowArrowButton"
import Autoplay from "embla-carousel-autoplay"

const EmblaCarousel = ({ slides }) => {
  // Lazy state gives the plugin a stable identity that's safe to read in render
  const [autoplay] = useState(() =>
    Autoplay({
      delay: 3000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      rootNode: (emblaRoot) => emblaRoot.parentElement,
    }),
  )

  const [viewportRef, embla] = useEmblaCarousel(
    {
      // align: "center",
      skipSnaps: false,
      loop: true,

      breakpoints: {
        "(max-width: 660px)": { slidesToScroll: 1, align: "center" },
        "(min-width: 660px)": { slidesToScroll: 2 },
        "(min-width: 920px)": { slidesToScroll: 1, align: "center" },
      },
    },
    [autoplay], /// toggle autoplay off
  )
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)

  const scrollPrev = useCallback(() => {
    if (!embla) {
      return
    }
    embla.scrollPrev()
    autoplay.reset()
  }, [embla, autoplay])
  const scrollNext = useCallback(() => {
    if (!embla) {
      return
    }
    embla.scrollNext()
    autoplay.reset()
  }, [embla, autoplay])

  const onSelect = useCallback(() => {
    if (!embla) return
    setPrevBtnEnabled(embla.canScrollPrev())
    setNextBtnEnabled(embla.canScrollNext())
  }, [embla])

  useEffect(() => {
    if (!embla) return
    embla.on("select", onSelect)
    // Initial sync from the embla external system once it initializes.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    onSelect()
  }, [embla, onSelect])

  const renderPageButtons = () => {
    return (
      <div className=" flex flex-row justify-end items-center" key={"page-buttons"}>
        <div className="flex flex-row w-[130px] justify-between">
          <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
          <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
        </div>
      </div>
    )
  }

  return [
    renderPageButtons(),
    <div
      className="overflow-hidden w-[351px] min-[425px]:w-full pb-[10px]"
      ref={viewportRef}
      key={"embla-carousel"}
    >
      <div className="flex flex-row">
        {map(slides, (slide, index) => (
          <div className="mx-[13px]" key={`group-card-${index}`}>
            {/* //mr-[36px]  */}
            {slide}
          </div>
        ))}
      </div>
    </div>,
  ]
}

export default EmblaCarousel
